// extracted by mini-css-extract-plugin
export default {"table-menu":"TableMenu_table-menu__mkeAX","table-menu__divider":"TableMenu_table-menu__divider__w5XXb"};